// extracted by mini-css-extract-plugin
export default {"youtubeBlock":"YouTubeBlock_youtubeBlock__P1-r8","youTubeInput":"YouTubeBlock_youTubeInput__bqLyy"};